// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue';
import VueLodash from 'vue-lodash';
import App from '@/App'
import router from '@/router'
import store from '@/store'
import MessageBox from '@/components/MessageBox'
import Toastr from 'vue-toastr';
import service from '@/service';
import filters from '@/filters';
import vSelect from 'vue-select';
import vCalendar from 'v-calendar';
import vTimepicker from 'vue2-timepicker';
import vMultiselect from 'vue-multiselect';
import vNumeralFilter from 'vue-numeral-filter';
import VueCurrencyInput from 'vue-currency-input';
import axios from 'axios';

import 'vue-select/dist/vue-select.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';

Vue.use(VueCurrencyInput, {
	globalOptions: {
		currency: 'EUR',
		locale: 'sl'
	}
});

Vue.use(filters);

Vue.use(BootstrapVue);
Vue.use(VueLodash, { name: 'lodash' });
Vue.use(vNumeralFilter, {
	locale: 'sl'
});

Vue.component('app-mbox', MessageBox);
require('vue-toastr/src/vue-toastr.scss');
Vue.component('vue-toastr', Toastr);
Vue.component('v-select', vSelect);
Vue.component('v-multiselect', vMultiselect);
Vue.component('v-timepicker', vTimepicker);

Vue.use(vCalendar, {
	locales: {
		'sl-SI': {
			firstDayOfWeek: 2,
			masks: {
				L: 'DD. MM. YYYY',
				weekdays: 'WW'
			}
		}
	}
});

const fb = require('@/firebase.config.js');

const ebus = new Vue();
Object.defineProperties(Vue.prototype, {
	$bus: {
		get: function () {
			return ebus;
		}
	}
});

Vue.mixin({
	data: function () {
		return {
			moneyFormatter: new Intl.NumberFormat('sl', { style: 'currency', currency: 'EUR' })
		}
	}
});

/* eslint-disable no-new */
let app;
fb.auth.onAuthStateChanged(fbUser => {
	if (!app) {
		if (fbUser) {
			let loginUser = {
				id: fbUser.uid,
				display_name: fbUser.displayName,
				email: fbUser.email,
				phoneNumber: fbUser.phoneNumber,
				photoURL: fbUser.photoURL,
				creationTime: fbUser.metadata.creationTime,
				lastSignInTime: fbUser.metadata.lastSignInTime
			};
			// get database object
			fbUser.getIdToken().then(idToken => {
				store.dispatch('setToken', idToken);
				axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`;
				service.getUser(loginUser)
					.then(response => {
						loginUser.dbid = response.data.id;
						loginUser.first_name = response.data.first_name;
						loginUser.last_name = response.data.last_name;
						loginUser.role = response.data.role;
						loginUser.last_access_at = response.data.last_access_at;
						loginUser.last_access_ip = response.data.last_access_ip;
						// store user
						store.dispatch('setUser', loginUser);
					})
					.catch(error => {
						if (error) {
							store.dispatch('setUser', null);
							store.dispatch('setToken', null);
						}
					});
			}).catch(function (error) {
				if (error) {
					store.dispatch('setUser', null);
					store.dispatch('setToken', null);
				}
			});
		} else {
			store.dispatch('setUser', null);
			store.dispatch('setToken', null);
		}
		if (store.getters.token) {
			axios.defaults.headers.common['Authorization'] = `Bearer ${store.getters.token}`;
		}
		app = new Vue({
			el: '#app',
			router,
			store,
			template: '<App/>',
			components: {
				App
			},
			created () {
			}
		});
	}
});
// listen to token change
fb.auth.onIdTokenChanged(fbUser => {
	if (fbUser) {
		fbUser.getIdToken().then(idToken => {
			store.dispatch('setToken', idToken);
			axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`;
		}).catch(function (error) {
			if (error) {
				console.error(error);
			}
		});
	}
});



// WEBPACK FOOTER //
// ./src/main.js